import { useEffect, useState } from "react"
import { useParams } from "react-router-dom";

import Sidebar from "../../components/Sidebar"
import AdminHome from "./AdminHome";
import ProfileAdmin from "./ProfileAdmin";
import ReportAdmin from "./ReportAdmin";
import AssessmentAdmin from "./AssessmentAdmin";

import { Container, Grid } from "@mui/material"
import UsersAdmin from "./UsersAdmin";
import EmailTemplatesAdmin from "./EmailTemplatesAdmin";

const Dashboard = ({active}) => {

    const {slugAssessment} = useParams();
    const [location, setLocation] = useState();
    const [subItem, setSubItem] = useState();

    useEffect(() => {
        if(active === "assessment"){
            setSubItem(slugAssessment);
        }else{
            setSubItem(undefined);
        }
        setLocation(active);
    }, [active,slugAssessment]);

    return (
    <Container maxWidth={false} sx={{padding:"0px!important"}}> 
        <Grid container sx={{height:"calc(100vh - 84px)"}}>
            <Grid size={2}>
                <Sidebar location={location} subItem={subItem}/>
            </Grid>
            <Grid size={10}>
                <Container maxWidth={"xl"} sx={{padding:"50px"}}>
                    {
                        location === "home" && <AdminHome/>
                    }
                    {
                        location === "profile" && <ProfileAdmin/>
                    }
                    {
                        location === "report" && <ReportAdmin/>
                    }
                    {
                        location === "assessment" && <AssessmentAdmin/>
                    }
                    {
                        location === "users" && <UsersAdmin/>
                    }
                    {
                        location === "email_templates" && <EmailTemplatesAdmin/>
                    }
                </Container>
            </Grid>
        </Grid>   
    </Container>
    )
}

export default Dashboard